/** 기존 ERP 디자인 토큰 (커스텀 테마가 없으므로 상수로 통일) */
export const C = {
  blue: "rgb(0,0,255)",
  navy: "rgb(11,12,105)",
  blueSoft: "rgba(0,0,255,0.05)",
  blueSoft2: "rgba(0,0,255,0.10)",
  blueBorder: "rgba(0,0,255,0.25)",
  grey: "rgb(151,151,151)",
  greyText: "#5b6270",
  border: "#e2e4e9",
  borderSoft: "#eef0f4",
  bg: "#f5f5f5",
  panel: "#ffffff",
  text: "#1f2430",
};
